export const BROWSER = typeof window !== "undefined";
export const DEV = false;
export const NODE = false;
